document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.carousel-image');
    const thumbnails = document.querySelectorAll('.carousel-thumbnail');
    const thumbnailContainer = document.querySelector('.carousel-thumbnails');
    const currentSlideElement = document.querySelector('.current-slide');
    const totalSlidesElement = document.querySelector('.total-slides');
    const carouselImagesContainer = document.querySelector('.carousel-images');
    let currentIndex = 0;
    let isScrolling = false;
    let startX, endX;

    const updateCarousel = (index) => {
        images.forEach((img, i) => {
            img.classList.toggle('active', i === index);
        });
        thumbnails.forEach((thumb, i) => {
            thumb.parentElement.classList.toggle('active', i === index);
        });
        if (currentSlideElement) {
            currentSlideElement.textContent = index + 1;
        }
    };

    const scrollToImage = (index) => {
        isScrolling = true;
        carouselImagesContainer.scrollTo({
            left: images[index].offsetLeft,
            behavior: 'smooth'
        });
        setTimeout(() => {
            isScrolling = false;
        }, 300); // Match the CSS transition duration
    };

    const showPreviousImage = () => {
        if (currentIndex > 0) {
            currentIndex -= 1;
            scrollToImage(currentIndex);
            updateCarousel(currentIndex);
        }
    };

    const showNextImage = () => {
        if (currentIndex < images.length - 1) {
            currentIndex += 1;
            scrollToImage(currentIndex);
            updateCarousel(currentIndex);
        }
    };

    const handleSwipe = () => {
        const deltaX = endX - startX;
        if (deltaX > 50) {
            showPreviousImage();
        } else if (deltaX < -50) {
            showNextImage();
        }
    };

    const enableMobileFeatures = () => {
        carouselImagesContainer.addEventListener('touchstart', (event) => {
            startX = event.touches[0].clientX;
        });

        carouselImagesContainer.addEventListener('touchend', (event) => {
            endX = event.changedTouches[0].clientX;
            handleSwipe();
        });

        carouselImagesContainer.addEventListener('scroll', () => {
            if (!isScrolling) {
                const index = Math.floor(carouselImagesContainer.scrollLeft / images[0].clientWidth);
                console.log('scrollLeft:', carouselImagesContainer.scrollLeft);
                console.log('clientWidth:', images[0].clientWidth);
                console.log('index:', index);
                if (index !== currentIndex) {
                    currentIndex = index;
                    updateCarousel(currentIndex);
                }
            }
        });
    };

    const disableMobileFeatures = () => {
        carouselImagesContainer.removeEventListener('touchstart', handleSwipe);
        carouselImagesContainer.removeEventListener('touchend', handleSwipe);
        carouselImagesContainer.removeEventListener('scroll', updateCarousel);
    };

    const handleResize = () => {
        if (window.innerWidth <= 767) {
            enableMobileFeatures();
        } else {
            disableMobileFeatures();
        }
    };

    window.addEventListener('resize', handleResize);

    thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
            currentIndex = index;
            scrollToImage(currentIndex);
            updateCarousel(currentIndex);
        });
    });

    updateCarousel(currentIndex);
    handleResize();
    
});


